import styled from "styled-components";

const Section = styled.section`
  text-align: center;
  @media screen and (max-width: 600px) {
    width: 100%;
  }
`;

export default Section;
